<template>
  <div>
    <div class="order-state">
      <div class="state">{{detail.orderState == "3"?"待厂家发货":detail.orderState == "4"?"厂家已发货":detail.orderState == "5"?"订单已完成":"交易关闭"}}</div>
      <div class="btn">
        <van-button
          type="default"
          text="提醒商家发货"
          class="order-btn pick-btn"
          v-if="detail.orderState==3"
          @click.stop="tips()"
        />
        <van-button
          type="default"
          text="确认提货"
          class="order-btn pick-btn"
          v-if="detail.orderState==4"
          @click="submit"
        />
        <van-button
          type="default"
          text="查看物流"
          class="order-btn"
          v-if="detail.orderState!=3"
          :to="{path:'/logistics',query: {orderId: detail.orderId}}"
        />
      </div>
    </div>
    <div class="order-wl">
      <div class="wl-title">配送信息</div>
      <div class="wl-common van-hairline--bottom">
        <span>收货人</span>
        <span>{{detail.buyerName}}</span>
      </div>
      <div class="wl-common">
        <span>收货地址</span>
        <span class="van-multi-ellipsis--l3">{{detail.buyerAddress}}</span>
      </div>
    </div>
    <div class="order-goods">
      <div class="flex-between">
        <div class="shop-name van-ellipsis">{{detail.sellerName}}</div>
        <div class="shop-phone">
          <img
            src="../../assets/img/order_send.png"
            alt
            @click="callPhone(detail.sellerPhone)"
          />
        </div>
      </div>
      <div
        class="goods-item"
        v-for="(goods,index) in detail.ordersProduct"
        :key="index"
      >
        <div class="good-img">
          <img
            :src="imgPrex+goods.imageUrl"
            alt
          />
          <span v-show="goods.refundState == 1||goods.refundState == 3">{{goods.refundState == 1?"退款中":"已退款"}}</span>
        </div>
        <div class="good-cont">
          <div class="goods-name van-ellipsis">
            <span
              style="background: linear-gradient(90deg, #78E71E 0%, #15AD26 100%);"
              v-if="goods.type == 5 || goods.type == 6 || goods.type == 7"
            >同城</span>
            <span
              style="background: linear-gradient(90deg, #FB6A4A 0%, #FF0808 100%, #FF0808 100%);"
              v-if="goods.type == 3 || goods.type == 6"
            >秒杀</span>
            <span
              style="background: linear-gradient(90deg, #4DA0FF 0%, #336DF7 100%);"
              v-if="goods.type == 4 || goods.type == 7"
            >拼单</span>
            <span
              style="background: linear-gradient(90deg, #F2B05B 0%, #FF7617 100%);"
              v-if="goods.isRecommend == 1"
            >推荐</span>
            <b>{{goods.productName}}</b>
          </div>
          <div
            class="goods-dvTime"
            v-show="goods.dvTime"
          ><span class="van-hairline--surround">{{goods.dvTime}}</span></div>
          <div class="info-price flex-between">
            <div class="count">x{{goods.count | integer}}</div>
            <div style="font-size: 0"><span
                class="disPrice"
                v-show="goods.totalSellerSalePrice"
              >¥{{goods.totalSellerSalePrice}}</span><span class="price">¥{{goods.totalMoneyPrice}}</span></div>
          </div>
        </div>
      </div>
      <div class="goods-line van-hairline--top"></div>
      <div class="goods-freight flex-between van-hairline--bottom">
        <span>邮费</span>
        <span>免费配送</span>
      </div>
      <div class="order-total">
        <span style="color: #8D8D8D">已优惠</span>
        <span class="price">¥{{detail.reducedPrice}}</span>
        <span>小计</span>
        <span class="total">¥{{detail.moneyOrder}}</span>
      </div>
    </div>
    <div class="order-info">
      <div class="info-title">配送信息</div>
      <div class="info-common van-hairline--bottom">
        <span>订单编码</span>
        <span>{{detail.orderSn}}</span>
      </div>
      <div class="info-common van-hairline--bottom">
        <span>下单时间</span>
        <span>{{detail.createTime}}</span>
      </div>
      <div class="info-common">
        <span>订单备注</span>
        <span class="van-multi-ellipsis--l3">{{detail.note?detail.note:"-"}}</span>
      </div>
      <div
        class="info-common van-hairline--top"
        v-if="detail.cancelOrderReason"
      >
        <span>关闭原因</span>
        <span class="van-multi-ellipsis--l3">{{detail.cancelOrderReason}}</span>
      </div>
    </div>
    <van-popup
      v-model="showPhone"
      class="phone-popup"
    >
      <div
        v-for="(item,index) in phoneList"
        :key="index"
        @click="dialPhone(item)"
        class="van-hairline--bottom"
      >{{item}}</div>
    </van-popup>
  </div>
</template>

<script>
import { ordersDetail, confirmReceipt, csPushDelivery } from "@/api/join";
export default {
  data() {
    return {
      detail: {},
      showPhone: false,
      phoneList: []
    };
  },
  filters: {
    integer(val) {
      return parseInt(val);
    }
  },
  methods: {
    callPhone(phone) {
      let phoneList = phone.split(",");
      if (phoneList.length > 1) {
        this.phoneList = phoneList;
        this.showPhone = true;
      } else {
        this.dialPhone(phone);
      }
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = 'tel:' + phone;
      } else {
        window.Android.dialPhone(phone);
      }
      this.showPhone = false;
    },
    // 提醒发货
    tips() {
      csPushDelivery({
        orderId: this.detail.orderId
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$toast("提醒商家发货成功～");
        }
      });
    },
    submit() {
      this.$dialog.alert({
        message: "用户已收到商品并确认提货？",
        confirmButtonText: "确定",
        confirmButtonColor: "#1993FF",
        cancelButtonText: "取消",
        cancelButtonColor: "#1D1D1D",
        showCancelButton: true,
      })
        .then(() => {
          confirmReceipt(`ordersId=${this.detail.orderId}&token=${this.$store.getters.token}`).then((res) => {
            if (res.appStatus.errorCode == 0) {
              this.detail.orderState = 5;
              this.$store.commit("user/SET_modifyOrderState", true);
            }
          });
        });
    },
    ordersDetail() {
      ordersDetail({
        orderId: this.$route.query.orderId,
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.detail = res.content;
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/logistics") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      this.ordersDetail();
    }
    this.$route.meta.isBack = false;
  },
};
</script>

<style lang="scss" scoped>
.order-state {
  padding: 0 15px;
  background-color: #ffffff;
  .state {
    height: 56px;
    padding: 10px 0 15px;
    font-size: 24px;
    font-weight: 800;
    box-sizing: border-box;
  }
  .btn {
    height: 50px;
    display: flex;
    align-items: center;
  }
  .order-btn {
    height: 30px;
    padding: 0 10px;
    font-size: 14px;
    color: #1d1d1d;
    border-radius: 5px;
    &:first-child {
      margin-right: 10px;
    }
  }
  .pick-btn {
    color: #ffffff;
    background: linear-gradient(91deg, #5ec3e7 0%, #0083f6 100%);
  }
}
.order-wl,
.order-goods,
.order-info {
  margin-top: 10px;
  padding: 0 15px;
  background-color: #ffffff;
}
.wl-title,
.shop-name,
.info-title {
  height: 50px;
  line-height: 50px;
  font-size: 17px;
  font-weight: 800;
}
.shop-phone {
  width: 31px;
  height: 31px;
  img {
    width: 100%;
    height: 100%;
  }
}
.wl-common,
.info-common {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  font-size: 15px;
  span:first-of-type {
    flex: 0 0 100px;
    color: #8d8d8d;
  }
}
.shop-name {
  max-width: 80%;
  position: relative;
}
.goods-item {
  display: flex;
  padding: 10px 0;
  .good-img {
    width: 84px;
    height: 84px;
    margin-right: 10px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
    span {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 1px 0;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  .good-cont {
    flex: 1;
    position: relative;
    overflow: hidden;
    .goods-name {
      font-size: 15px;
      span {
        margin-right: 4px;
        padding: 0 1px;
        font-size: 11px;
        color: #ffffff;
        border-radius: 1px;
        vertical-align: middle;
      }
      b {
        font-weight: 800;
        vertical-align: middle;
      }
    }
    .goods-dvTime {
      font-size: 12px;
      margin-top: 2px;
      color: #208fff;
      span {
        padding: 1px 4px;
      }
    }
    .info-price {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      .count {
        font-size: 12px;
        color: #999999;
      }
      .price {
        font-size: 16px;
        font-weight: 800;
      }
      .disPrice {
        margin-right: 6px;
        font-size: 14px;
        color: #a4a4a4;
        text-decoration: line-through;
      }
    }
  }
}
.goods-line {
  height: 10px;
}
.goods-freight {
  height: 50px;
  font-size: 15px;
}
.order-total {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  text-align: right;
  background-color: #ffffff;
  .price {
    margin-right: 10px;
    color: #ff1310;
  }
  .total {
    font-size: 18px;
    font-weight: bold;
    color: #ff1310;
  }
}
.phone-popup {
  width: 241px;
  text-align: center;
  border-radius: 5px;
  div {
    font-size: 14px;
    height: 48px;
    line-height: 48px;
  }
}
</style>
<style scoped>
.good-cont >>> [class*="van-hairline"]::after {
  border-color: #208fff;
}
</style>